import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const exampleBlock = {
  40007: [
    'Learn new fire safety information',
    'Gain awareness of the benefits of exercise',
    'Learn about the negative impacts of smoking',
    'Learn hurricane preparedness best practices',
  ],
  40008: [
    'Create a business plan ',
    'Exercise more ',
    'Complete an internship',
    'Quit smoking',
    'Eat more fruits and vegetables',
    'Complete a thesis / big project',
    'Fire/storm-proof one’s home',
  ],
};

interface ExampleTextProps {
  questionId: number;
}

const StyledDiv = styled.div`
  margin-top: ${SPACERS.extraLarge};
`;

const ExampleText: React.FC<ExampleTextProps> = ({ questionId }) => {
  if (exampleBlock[questionId]) {
    return (
      <StyledDiv>
        <TrueImpactText align="center" variant="heading-subheading">
          Some examples:
        </TrueImpactText>
        <ul>
          {exampleBlock[questionId].map((x: string) => (
            <li key={x}>{x}</li>
          ))}
        </ul>
      </StyledDiv>
    );
  }

  return null;
};

export default ExampleText;
